/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Stage_WonInputs */

const cs_pipelines_stage_won = /** @type {(inputs: Pipelines_Stage_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fáze výhry`)
};

const en_pipelines_stage_won = /** @type {(inputs: Pipelines_Stage_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Won stage`)
};

/**
* | output |
* | --- |
* | "Won stage" |
*
* @param {Pipelines_Stage_WonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_stage_won = /** @type {((inputs?: Pipelines_Stage_WonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Stage_WonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_stage_won(inputs)
	return cs_pipelines_stage_won(inputs)
});